"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceMediaBody = _interopRequireDefault(require("./SourceMediaBody"));
var _ = require("../..");
var SourceListVideoFileItemBody = function SourceListVideoFileItemBody(_ref) {
  var value = _ref.value,
    hidden = _ref.hidden,
    live = _ref.live,
    thumbnail = _ref.thumbnail,
    onThumbnailReady = _ref.onThumbnailReady,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    onSourceDeleted = _ref.onSourceDeleted;
  return /*#__PURE__*/_react["default"].createElement(_SourceMediaBody["default"], {
    key: "source-video-".concat(value),
    type: _.VIDEO_FILE,
    value: value,
    hidden: hidden,
    live: live,
    thumbnail: thumbnail,
    onThumbnailReady: onThumbnailReady,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    onSourceDeleted: onSourceDeleted
  });
};
SourceListVideoFileItemBody.propTypes = {
  value: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  live: _propTypes["default"].bool,
  thumbnail: _propTypes["default"].string,
  onThumbnailReady: _propTypes["default"].func,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  onSourceDeleted: _propTypes["default"].func
};
var _default = exports["default"] = SourceListVideoFileItemBody;